var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "基本信息",
        visible: _vm.editInfoVisible,
        width: "628px",
        "before-close": _vm.handleClose,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.editInfoVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { rules: _vm.rules, model: _vm.form, "label-width": "170px" },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "固件名称", prop: "name" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("span", [_vm._v("固件名称")]),
                              _vm._v(" \n            "),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: "仅用于管理固件，不对外显示",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "iconfont icon-wenhao",
                                  }),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c("el-input", {
                        staticClass: "name-input",
                        attrs: {
                          maxlength: "32",
                          "show-word-limit": "",
                          placeholder: "请输入固件名称",
                        },
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "固件类型", prop: "componentType" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("span", [_vm._v("固件类型")]),
                              _vm._v(" \n            "),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: { placement: "top" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "content",
                                      fn: function () {
                                        return [
                                          _c("p", [
                                            _vm._v(
                                              "①MCU SDK开发上传MCU固件时建议选择MCU固件;"
                                            ),
                                          ]),
                                          _c("p", [
                                            _vm._v(
                                              "②其他开发方式，主通讯固件请选择'模组固件;"
                                            ),
                                          ]),
                                          _c("p", [
                                            _vm._v(
                                              "③如果模组固件被占用，可以根据自己模组通讯类型选择;"
                                            ),
                                          ]),
                                          _c("p", [
                                            _vm._v(
                                              "④如果固件类型置灰不可选，请查看是否有相同类型的固件;"
                                            ),
                                          ]),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                },
                                [
                                  _c("i", {
                                    staticClass: "iconfont icon-wenhao",
                                  }),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.form.componentTypeName))])]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "升级通道号",
                        prop: "upgradeChannelNumber",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("span", [_vm._v("升级通道号")]),
                              _vm._v(" \n            "),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: { placement: "top" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "content",
                                      fn: function () {
                                        return [
                                          _vm._v(
                                            "\n                用于固件OTA对应升级，需要将通道号写入固件。(固件类型为模组固件、蓝牙固件、Zigbee固件、MCU固件已经写好)\n              "
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                },
                                [
                                  _c("i", {
                                    staticClass: "iconfont icon-wenhao",
                                  }),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.form.upgradeChannelNumber)),
                      ]),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "自定义编号", prop: "customNumber" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("span", [_vm._v("自定义编号")]),
                              _vm._v(" \n            "),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: { placement: "top" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "content",
                                      fn: function () {
                                        return [
                                          _vm._v(
                                            "\n                用于集中器等同一个PID设备内由于接入设备品牌不一致需要不同固件的设备使用，可不填。不填则根据默认方式进行填充。默认为0，即为常规通道\n              "
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                },
                                [
                                  _c("i", {
                                    staticClass: "iconfont icon-wenhao",
                                  }),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入自定义编号" },
                        model: {
                          value: _vm.form.customNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "customNumber", $$v)
                          },
                          expression: "form.customNumber",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "固件升级超时时间", prop: "timeoutTime" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("span", [_vm._v("固件升级超时时间")]),
                              _vm._v(" \n            "),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content:
                                      "用于规定OTA等待时间，超时判定为升级失败，可根据固件包大小和用户体验适当调整",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "iconfont icon-wenhao",
                                  }),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: {
                            type: "number",
                            max: "1800",
                            min: "1",
                            placeholder: "请输入1~1800",
                          },
                          model: {
                            value: _vm.form.timeoutTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "timeoutTime", $$v)
                            },
                            expression: "form.timeoutTime",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("秒")])],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "单次间隔升级超时时间",
                        prop: "singleTimeout",
                      },
                    },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: {
                            type: "number",
                            max: "1800",
                            min: "1",
                            placeholder: "请输入1~1800",
                          },
                          model: {
                            value: _vm.form.singleTimeout,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "singleTimeout", $$v)
                            },
                            expression: "form.singleTimeout",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("秒")])],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注说明", prop: "description" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          maxlength: "200",
                          "show-word-limit": "",
                          placeholder: "请输入",
                        },
                        model: {
                          value: _vm.form.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "description", $$v)
                          },
                          expression: "form.description",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "14" }, on: { click: _vm.handleClose } },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "14" },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }